// ============ COMPONENTE INDICADOR DE ESTADO OFFLINE ============
// client/src/components/ui/offline-indicator.tsx

import { useOffline } from "@/lib/hooks/use-offline";
import { useOfflineContext } from "@/lib/contexts/offline-context";
import { WifiOff, RefreshCw, Package, ShoppingBag } from "lucide-react";
import { useEffect, useState } from "react";

export function OfflineIndicator() {
  const { isOffline, wasOffline } = useOffline();
  const { pendingOperationsCount, pendingInventoryCount, pendingSalesCount } =
    useOfflineContext();
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (wasOffline) {
      setShowReconnected(true);
      const timer = setTimeout(() => setShowReconnected(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [wasOffline]);

  // Determinar si debemos mostrar la barra
  const shouldShowBar = isOffline || showReconnected;

  return (
    <>
      {/* ============ BARRA FLOTANTE ============ */}
      {shouldShowBar && (
        <div className="fixed top-0 left-0 right-0 z-50">
          {isOffline ? (
            // ============ BARRA DE ESTADO OFFLINE ============
            <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-lg text-sm">
              <div className="flex items-center gap-2">
                <WifiOff className="h-4 w-4" />
                <span className="font-medium hidden sm:inline">
                  Modo sin conexión
                </span>
                <span className="text-xs sm:text-sm text-amber-100">
                  Cambios guardados localmente
                </span>
              </div>

              {/* Contadores de operaciones pendientes */}
              <div className="flex items-center gap-2">
                {pendingInventoryCount > 0 && (
                  <div className="bg-amber-600 px-2 py-0.5 rounded-full text-xs font-bold flex items-center gap-1">
                    <Package className="h-3 w-3" />
                    <span>{pendingInventoryCount}</span>
                  </div>
                )}
                {pendingSalesCount > 0 && (
                  <div className="bg-amber-600 px-2 py-0.5 rounded-full text-xs font-bold flex items-center gap-1">
                    <ShoppingBag className="h-3 w-3" />
                    <span>{pendingSalesCount}</span>
                  </div>
                )}
                {pendingOperationsCount > 0 &&
                  pendingInventoryCount === 0 &&
                  pendingSalesCount === 0 && (
                    <div className="bg-amber-600 px-2 py-0.5 rounded-full text-xs font-bold">
                      {pendingOperationsCount} pendiente
                      {pendingOperationsCount !== 1 ? "s" : ""}
                    </div>
                  )}
              </div>
            </div>
          ) : (
            // ============ BARRA DE RECONEXIÓN ============
            <div className="bg-green-500 text-white px-4 py-2 flex items-center justify-between shadow-lg text-sm">
              <div className="flex items-center gap-2">
                <RefreshCw className="h-4 w-4 animate-spin" />
                <span className="hidden sm:inline">Conexión restablecida</span>
                <span className="text-xs sm:text-sm">
                  Sincronizando datos...
                </span>
              </div>
              <div className="w-16 h-1 bg-green-600 rounded-full overflow-hidden">
                <div className="h-full bg-white animate-[progress_2s_ease-in-out_infinite]"></div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ============ ESPACIADOR DINÁMICO ============ */}
      {/* Este div empuja el contenido hacia abajo SOLO cuando la barra está visible */}
      {shouldShowBar && <div className="h-12" />}
    </>
  );
}
